import { Link } from 'react-router-dom';
import { APP_CONFIG, FOOTER_LINKS, CONTACT } from '@/config/constants';
import iconSrc from '@/assets/branding/notematic-icon.png';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-50 dark:bg-secondary-900 border-t border-secondary-200 dark:border-secondary-800">
      <div className="container-custom py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <img
                src={iconSrc}
                alt=""
                className="h-9 w-9"
                draggable={false}
              />
              <span className="text-xl font-semibold text-secondary-900 dark:text-white tracking-tight">
                {APP_CONFIG.name}
              </span>
            </div>
            <p className="text-sm text-secondary-600 dark:text-secondary-400 max-w-md mb-4">
              Secure AI-assisted clinical documentation platform for mental health practitioners
              in Australia. Privacy-first, compliant, and designed for clinicians.
            </p>
            <div className="text-sm text-secondary-600 dark:text-secondary-400">
              <p>{CONTACT.address}</p>
              <p className="mt-1">
                <a
                  href={`mailto:${CONTACT.email}`}
                  className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
                >
                  {CONTACT.email}
                </a>
              </p>
            </div>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="text-sm font-semibold text-secondary-900 dark:text-white mb-4">
              Legal
            </h3>
            <ul className="space-y-2">
              {FOOTER_LINKS.legal.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-secondary-600 dark:text-secondary-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h3 className="text-sm font-semibold text-secondary-900 dark:text-white mb-4">
              Company
            </h3>
            <ul className="space-y-2">
              {FOOTER_LINKS.company.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-secondary-600 dark:text-secondary-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-secondary-200 dark:border-secondary-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-secondary-600 dark:text-secondary-400">
              © {currentYear} {APP_CONFIG.name}. All rights reserved.
            </p>
            <div className="flex items-center space-x-4">
              <span className="text-xs text-secondary-500 dark:text-secondary-500">
                Built with security and privacy first
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

